module.exports = __webpack_public_path__ + "media/images/bg_sp-71e2ccae4ceea15c299a97c2b59e53a9.png";